import * as z from 'zod';

export const boolean = z.enum(['true', 'false']).transform((x) => x === 'true');
export const brand = z.enum(['qantas', 'jetstar']);
export const shortDate = z.string().refine((s) => !isNaN(Date.parse(s)), { message: 'Not a valid date.' });
